module.exports = __webpack_public_path__ + "static/media/Agile Scrum.e5f96afd.png";